import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { ROUTES } from '../../../config/constants';
import './TenantSelectionForm.css';

const TenantSelectionForm = () => {
    const navigate = useNavigate();
    const { availableTenants, selectTenant } = useAuth();
    const [selectedTenant, setSelectedTenantLocal] = useState('');
    const [loading, setLoading] = useState(false);

    const handleTenantChange = (e) => {
        setSelectedTenantLocal(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedTenant) {
            return;
        }

        setLoading(true);

        try {
            const tenant = availableTenants.find(t => t.id === selectedTenant);
            const result = await selectTenant(tenant);

            if (result.success) {
                navigate(ROUTES.DASHBOARD);
            }
        } catch (err) {
            console.error('Mandanten-Auswahl fehlgeschlagen:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/login');
    };

    return (
        <form onSubmit={handleSubmit} className="tenant-selection-form">
            <div className="form-header">
                <p>Bitte wählen Sie den Mandanten aus, mit dem Sie arbeiten möchten:</p>
            </div>


            <div className="tenant-list">
                {availableTenants.map((tenant) => (
                    <div key={tenant.id} className="tenant-option">
                        <input
                            type="radio"
                            id={tenant.id}
                            name="tenant"
                            value={tenant.id}
                            checked={selectedTenant === tenant.id}
                            onChange={handleTenantChange}
                            className="tenant-radio"
                        />
                        <label htmlFor={tenant.id} className="tenant-label">
                            <div className="tenant-info">
                                <div className="tenant-name">{tenant.name}</div>
                                <div className="tenant-description">{tenant.legal}</div>
                                <div className="tenant-domain">{tenant.domain}</div>
                            </div>
                        </label>
                    </div>
                ))}
            </div>

            <div className="form-actions">
                <button
                    type="submit"
                    className="submit-button"
                    disabled={!selectedTenant || loading}
                >
                    {loading ? 'Wird geladen...' : 'Weiter zum Dashboard'}
                </button>
            </div>
        </form>
    );
};

export default TenantSelectionForm;